module.exports = __webpack_public_path__ + "static/HDBR-Cotidiano-1-494ad6c6227c564abb8e82c5e8140167.jpg";